export default __webpack_public_path__ + "static/media/Powered by Stripe - blurple.c4f72bcf.svg";